import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash/lang';
import {makeStyles, Snackbar, SnackbarContent, IconButton} from '@material-ui/core';
import {Close as CloseIcon} from '@material-ui/icons';
import {clearFlashMessage} from 'actions/flash-message';

const useStyles = makeStyles(({palette}) => ({
  root: {
    backgroundColor: ({msgType}) => ({success: palette.success.main, error: palette.error.main}[msgType]),
  },
  closeIcon: {
    color: palette.common.white,
  },
}));

const FlashMessage = ({flashMessage, clearFlashMessage}) => {
  const msgType = flashMessage.get('msgType');
  const message = flashMessage.get('message');
  const classes = useStyles({msgType});

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={!isEmpty(msgType) && !isEmpty(message)}
      message={message}
      autoHideDuration={6000}
      onClose={clearFlashMessage}
    >
      <SnackbarContent
        className={clsx('flash-message', msgType, classes.root)}
        message={message}
        action={
          <IconButton onClick={clearFlashMessage}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        }
      />
    </Snackbar>
  );
};

FlashMessage.propTypes = {
  flashMessage: PropTypes.object.isRequired,
  clearFlashMessage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  flashMessage: state.flashMessage,
});

const mapDispatchToProps = (dispatch) => ({
  clearFlashMessage: () => dispatch(clearFlashMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FlashMessage);
